import { Button, Toggle } from '@mairistem/composants';
import { Sens } from '@mairistem/comptabilite';
import React from 'react';

interface CustomToggleProps {
	value: string;
	onChange: any;
	'data-testid'?: string;
}

const CustomToggle = ({
	value,
	onChange,
	'data-testid': dataTestId,
}: CustomToggleProps) => (
	<Toggle onChange={onChange}>
		<Button
			active={value === Sens.DEPENSE}
			data-testid={dataTestId && `${dataTestId}Depense`}
		>
			Dépense
		</Button>
		<Button
			active={value === Sens.RECETTE}
			data-testid={dataTestId && `${dataTestId}Recette`}
		>
			Recette
		</Button>
	</Toggle>
);

export default CustomToggle;
